import React from 'react';
import PropTypes from 'prop-types';
import { map } from 'lodash/fp';
import { FlexCol, SummaryModalHeader1, SummaryModalHeader2, SummaryModalTotals, SummaryModalProduct, SummaryModalProductList } from './styles';
import InstallationPricing from '../../InstallationPricing';
import Price from '../../Price';

const DesignSummary = ({
  className,
  designId,
  designName,
  products,
  totalCost,
}) => (
  <FlexCol className={className}>
    <SummaryModalHeader1>{designName} Summary</SummaryModalHeader1>
    <p>
        Based on your window treatments, measurements, and options, here are
        your costs for installation:
    </p>

    <SummaryModalHeader2>Products: </SummaryModalHeader2>
    <SummaryModalProductList>
      {map(({ productId, productName, subtotal }) => (
        <SummaryModalProduct key={productId}>
          <div>{productName}</div>
          <div />
          <Price>{subtotal}</Price>
        </SummaryModalProduct>
      ))(products)}
    </SummaryModalProductList>

    <SummaryModalHeader2>Service Cost Breakdown:</SummaryModalHeader2>
    <InstallationPricing designId={designId} />

    <SummaryModalTotals>
      <div>Total Cost</div>
      <Price>{totalCost}</Price>
    </SummaryModalTotals>
  </FlexCol>
);

DesignSummary.propTypes = {
  className: PropTypes.string,
  designId: PropTypes.string.isRequired,
  designName: PropTypes.string.isRequired,
  totalCost: PropTypes.number,
  products: PropTypes.arrayOf(PropTypes.shape({
    productName: PropTypes.string.isRequired,
    subtotal: PropTypes.number.isRequired,
    productId: PropTypes.string.isRequired,
  })),

};
DesignSummary.defaultProps = {
  className: '',
  products: [],
  totalCost: 0,
};

export default DesignSummary;
